import { render, staticRenderFns } from "./HpColumns.vue?vue&type=template&id=0d24b417&scoped=true&"
import script from "./HpColumns.vue?vue&type=script&lang=js&"
export * from "./HpColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d24b417",
  null
  
)

export default component.exports